"use client";

import type { PropsWithChildren } from "react";
import { usePathname } from "next/navigation";

import { AssistantOverlayProvider } from "@/features/assistant-overlay/AssistantOverlayProvider";
import { InstantAssistantProvider } from "@/features/instant-assistant/InstantAssistantProvider";

// Routes that should NOT activate the assistant overlay. Everything else —
// including the new namespace-scoped routes like /{slug}/tasks — does.
const DISABLED_ROUTE_PREFIXES = [
  "/login",
  "/oauth",
  "/onboarding",
  "/api",
  "/design-system",
  "/themed-shadcn",
  "/tokens",
  "/layout-tokens",
  "/layout-cheat-sheet",
  "/dev",
  "/cli",
  "/preview",
  "/react-flow",
  "/system",
];

export function InstantAssistantRouteBoundary({ children }: PropsWithChildren) {
  const pathname = usePathname() ?? "";
  const shouldEnable = pathname.length > 1
    && !DISABLED_ROUTE_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

  if (!shouldEnable) {
    return <>{children}</>;
  }

  return (
    <InstantAssistantProvider>
      <AssistantOverlayProvider>{children}</AssistantOverlayProvider>
    </InstantAssistantProvider>
  );
}
